import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.VehicleClass.Copy.IRequest;
type Response = Api.Core.VehicleClass.Copy.IResponse;
type Headers = Api.Core.VehicleClass.Copy.IHeaders;
const url = '/api/ProductManagement/VehicleClass/CopyVehicleModels/:fromClassId/:toClassId';
export default async function vehicleClassCopyApi(params?: Request): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.post,
    url: createPathFromRoute(url, params),
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
